import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SectionHeader from 'components/SectionHeader';
import StartupCaptableDate from 'components/StartupCaptableDate/components';
import FolderContent from 'routes/DataRoom/components/FolderContent';
import { useSearchParams } from 'react-router-dom';
import { ROUTE_STARTUP_PATH } from 'routes';
import { TOOL_CAP_TABLE, TOOL_USERS } from 'constants/tools';
import { useCounter } from 'utils/customHooks';
import { getFolder } from 'routes/DataRoom/modules/actions';
import { startupCanManage } from 'utils/functions';
import { Breadcrumb } from 'xland-ui';
import DocumentsProvider from 'routes/DataRoom/provider/DocumentsProvider';
import useCaptableBreadcrumb from 'routes/Captable/hook/useCaptableBreadcrumb';
import { getShareHolder } from '../../../../modules/actions';
import ShareholderPartner from './shareholderPartner';
import ShareholderTransactions from './shareholderTransactions';
import ShareholderUsers from './shareholderUsers';
import ShareholderHistorial from './shareholderHistorial';

function ShareholderInfo(props) {
  const {
    literals,
    literalsCountries,
    literalsCommon,
    literalsShareholder,
    match,
    currency,
    lang,
    startup,
    captable,
  } = props;

  const [shareholder, setShareHolder] = useState(null);
  const [shareholderFolder, setShareholderFolder] = useState(null);
  const [searchParams] = useSearchParams();
  const captableId = searchParams.get('captable') || null;
  const canViewUsers = startupCanManage(startup, TOOL_USERS) && startupCanManage(startup, TOOL_CAP_TABLE);
  const refresh = useCounter(0);

  const { CAP_TABLE_SHAREHOLDERS } = ROUTE_STARTUP_PATH;
  const { routes, nextRoutes } = useCaptableBreadcrumb(CAP_TABLE_SHAREHOLDERS, startup.id, captable.id);

  const getShareHolderInfo = async () => {
    await getShareHolder(match.params.id, match.params.shareholder, { captable: captableId })
      .then((sh) => {
        setShareHolder(sh);
        getFolder('startup', match.params.id, sh.folder)
          .then(shFolder => setShareholderFolder(shFolder));
      });
  };

  useEffect(() => {
    setShareHolder(null);
    getShareHolderInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh.value, captableId]);

  const breadcrumb = [
    ...routes,
    { name: `${shareholder?.firstname || ''} ${shareholder?.lastname || ''}`, loading: !shareholder },
  ];

  const tabs = [
    { key: 'partner', name: literals.partner },
    { key: 'historial', name: literals.historial },
    { key: 'transactions', name: literals.transactions },
    { key: 'users', name: literals.users, hidden: !canViewUsers },
    { key: 'documents', name: literals.documents },
  ];

  return (
    <>
      <Breadcrumb routes={breadcrumb} nextRoutes={nextRoutes} />
      <StartupCaptableDate startup={startup} captable={captable} noDate />
      <SectionHeader tabs={tabs}>
        {(tab) => (
          <>
            {tab === 'partner' && (
              <ShareholderPartner
                literals={literals}
                literalsCountries={literalsCountries}
                literalsCommon={literalsCommon}
                match={match}
                currency={currency}
                startup={startup}
                shareholder={shareholder}
                refresh={refresh}
                lang={lang}
              />
            )}
            {tab === 'historial' && (
              <ShareholderHistorial
                literals={literals}
                match={match}
                currency={currency}
              />
            )}
            {
              tab === 'transactions' && (
                <ShareholderTransactions
                  literals={literals}
                  literalsCommon={literalsCommon}
                  match={match}
                />
              )
            }
            {
              tab === 'users' && canViewUsers && (
                <ShareholderUsers
                  literals={literals}
                  literalsCommon={literalsCommon}
                  literalsShareholder={literalsShareholder}
                  match={match}
                  currency={currency}
                  shareholder={shareholder}
                  startup={startup}
                  lang={lang}
                />
              )
            }
            {
              tab === 'documents' && (
                <DocumentsProvider>
                  <FolderContent selectedFolder={shareholderFolder} />
                </DocumentsProvider>
              )
            }
          </>
        )}
      </SectionHeader>
    </>
  );
}

ShareholderInfo.propTypes = {
  literals: PropTypes.object.isRequired,
  literalsCountries: PropTypes.object.isRequired,
  literalsCommon: PropTypes.object.isRequired,
  literalsShareholder: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  currency: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  startup: PropTypes.object.isRequired,
  captable: PropTypes.object.isRequired,
};

export default ShareholderInfo;
